
export default function InitContactWidget() {
  const widgetButton = document.getElementById('contact-widget-button');
  const contactDialog: HTMLDialogElement | null = document.getElementById('contact-widget-dialog') as HTMLDialogElement | null;
  const contactDialogClose = document.getElementById('contact-widget-dialog-close');

  widgetButton?.addEventListener('click', () => contactDialog?.show());
  contactDialogClose?.addEventListener('click', () => contactDialog?.close());
}
